// extracted by mini-css-extract-plugin
export default {"list":"kD3KeUor5gCXVlmA60FO"};